<template>
  <v-list dense :color="color">
    <v-list-item v-for="(val, i) in data" :key="i" class="litem">
      <h3>
        {{ val.descricao }} | {{ Number(val.total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 }) }}
      </h3>
    </v-list-item>
  </v-list>
</template>
<script>
import Helpers from "@/mixins/helpers";
export default {
  mixins: [Helpers],
  props: ["data", "color"],
  created() {
    this.Helpers;
  },
};
</script>

<style scoped>
.litem {
  font-size: 1rem;
  margin-bottom: 4px;
  padding: 0;
  min-height: 32px;
}

.litem h3 {
  font-weight: 700;
  color: #333;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>